import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

type StyleProps = {
  hasSplitBackgroundColor: boolean;
};

const useStyles = createUseStyles(
  ({
    brandColors: {
      background: { light1, light2 },
    },
  }: CmsWrenchTheme) => ({
    container: ({ hasSplitBackgroundColor }: StyleProps) => ({
      background: hasSplitBackgroundColor
        ? `linear-gradient(to top, ${light2} 0%, ${light2} 66%, ${light1} 66%, ${light1} 100%)`
        : undefined,
    }),
    image: {
      width: '100%',
    },
  })
);

export default useStyles;
